// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#lx-online-booking-payment-request-confirmation .lx-online-booking-payment-request-confirmation__success-card p[data-v-ff1b9132]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
